export type UnsTopics = "" |
(string & {});